module.exports = __webpack_public_path__ + "assets/img/bg-line-mecha-0da65984.png";